import { render } from "./CustomTab.vue?vue&type=template&id=3907db82"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__